import escapeStringRegexp from "escape-string-regexp"
import { dateOptions } from "./getLocaleDateStringFromDate"

interface Args {
  language: string;
  dayAbbreviation: string;
  monthAbbreviation: string;
  yearAbbreviation: string;
  escapeSeparatorRegexp?: boolean;
}

interface Separator {
  index: number;
  value: string;
}

interface ReturnValue {
  dateFormat: string;
  dateFormatLength: number;
  separators: Separator[];
}

/*
 * this method returns a string like "DD/MM/YYYY" that represents how the user
 * may expect a date to be formatted based on their locale
 */
export function getLocaleDateFormat(args: Args): ReturnValue {
  const {
    language,
    dayAbbreviation,
    monthAbbreviation,
    yearAbbreviation,
    escapeSeparatorRegexp = false,
  } = args

  const formatter = new Intl.DateTimeFormat(
    language,
    dateOptions,
  )

  const parts = formatter.formatToParts(new Date())

  let dateFormat = ""
  let dateFormatLength = 0
  const separators: Separator[] = []

  for (const part of parts) {
    if (part.type === "day") {
      dateFormat += part.value.replaceAll(
        /./g,
        dayAbbreviation,
      )
    } else if (part.type === "month") {
      dateFormat += part.value.replaceAll(
        /./g,
        monthAbbreviation,
      )
    } else if (part.type === "year") {
      dateFormat += part.value.replaceAll(
        /./g,
        yearAbbreviation,
      )
    } else {
      const separator = escapeSeparatorRegexp
        ? escapeStringRegexp(part.value)
        : part.value

      dateFormat += separator

      separators.push({
        index: dateFormatLength,
        value: separator,
      })
    }

    dateFormatLength += part.value.length
  }

  return {
    dateFormat,
    dateFormatLength,
    separators,
  }
}
